/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import set from 'lodash/set';
import unset from 'lodash/unset';
import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {
    result: {},
    permit: {},
    divisionDetailsModal: { isOpen: false, divisionId: '' },
};

export default function permit(state = INITIALSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.GET_PERMIT:
            st = cloneState(state);
            st.permit.result = action.payload;
            delete st.permit.fetch_err;
            return st;

        case types.GET_PERMIT_ERROR:
            st = cloneState(state);
            st.permit.fetch_err = action.error;
            return st;

        case types.GET_LOTTERY:
            st = cloneState(state);
            st.lottery = action.payload;
            delete st.permit.lottery_err;
            return st;

        case types.GET_AGGREGATE_SEASON_RULES:
            st = cloneState(state);
            st.agg_season_rules = action.payload;
            delete st.agg_season_rules_err;
            return st;

        case types.GET_AGGREGATE_SEASON_ERROR:
            st = cloneState(state);
            st.agg_season_rules_err = action.error;
            return st;

        case types.GET_LOTTERY_ERROR:
            st = cloneState(state);
            st.permit.lottery_err = action.error;
            return st;

        case types.GET_COOPERATORS:
            st = cloneState(state);
            st.permit.cooperators = action.payload;
            delete st.permit.cooperators_err;
            return st;

        case types.GET_COOPERATORS_ERROR:
            st = cloneState(state);
            st.permit.cooperators_err = action.error;
            return st;

        case types.GET_COOPERATOR:
            st = cloneState(state);
            st.permit.cooperator = action.payload;
            delete st.permit.cooperator_err;
            return st;

        case types.GET_COOPERATOR_ERROR:
            st = cloneState(state);
            st.permit.cooperator_err = action.error;
            return st;

        case types.GET_ISSUANCE:
            st = cloneState(state);
            st.permit.issuance = action.payload;
            delete st.permit.fetch_err;
            return st;

        case types.GET_ISSUANCE_ERROR:
            st = cloneState(state);
            st.permit.fetch_err = action.error;
            st.permit.fetch_issuance_error = {
                msg: action.error,
                code: action.error_code,
            };
            return st;

        case types.GET_ISSUANCE_LIST:
            st = cloneState(state);
            st.permit.issuanceList = action.payload;
            return st;

        case types.CLEAR_ISSUANCE_LIST:
            st = cloneState(state);
            delete st.permit.issuanceList;
            return st;

        case types.GET_ISSUANCE_BY_STATUS:
            st = cloneState(state);
            if (st.permit.issuances === undefined) {
                st.permit.issuances = action.payload;
            } else {
                st.permit.issuances = {
                    ...action.payload,
                    ...state.permit.issuances,
                };
            }
            delete st.permit.fetch_err;
            return st;

        case types.GET_ISSUANCE_BY_STATUS_ERROR:
            st = cloneState(state);
            st.permit.fetch_err = action.error;
            return st;

        case types.POST_ISSUANCE:
            st = cloneState(state);
            st.permit.issuance = action.payload;
            delete st.permit.error;
            return st;

        case types.POST_ISSUANCE_ERROR:
            st = cloneState(state);
            st.permit.error = action.error;
            return st;

        case types.UPDATE_ISSUANCE:
            st = cloneState(state);
            st.update_issuance_result = action.payload.status;
            st.updated_issuance = action.payload.issuance;
            delete st.permit.error;
            return st;

        case types.UPDATE_ISSUANCE_ERROR:
            st = cloneState(state);
            st.permit.error = action.error;
            delete st.update_issuance_result;
            delete st.updated_issuance;
            return st;

        case types.CLEAR_ISSUANCE:
            st = cloneState(state);
            delete st.permit.issuance;
            return st;

        case types.CLEAR_EXISTING_ISSUANCE:
            st = cloneState(state);
            delete st.permit.existingIssuance;
            return st;

        case types.SEND_CURRENT_DATE:
            st = cloneState(state);
            st.permit.current_date = action.payload;
            return st;

        case types.GET_AVAILABILITY:
            const currentAvail = state.permit.availabilities[action.keyName];
            // if existing availability data is either missing or stale, to prevent race conditions for availability fetches
            if (
                !currentAvail ||
                !currentAvail.requestId ||
                currentAvail.requestId < action.requestId
            ) {
                st = cloneState(state);
                st.permit.availabilities = {};
                st.permit.availabilities[action.keyName] = {
                    error: undefined,
                    result: action.payload,
                    requestId: action.requestId,
                };
                delete st.permit.availability_err;
            }
            return st;

        case types.GET_AVAILABILITY_ERROR:
            st = cloneState(state);
            if (st.permit.availabilities === undefined) {
                st.permit.availabilities = {};
            }
            st.permit.availabilities = {
                ...st.permit.availabilities,
                [action.keyName]: {
                    error: action.error,
                    result: undefined,
                },
            };
            st.permit.availability_err = action.error;
            delete st.permit.availability;
            return st;

        case types.CLEAR_AVAILABILITIES:
            st = cloneState(state);
            st.permit.availabilities = {};
            st.permit.monthlyAvailabilities = {};
            return st;

        case types.SAVE_FILTERS:
            st = cloneState(state);
            st.permit.filters = action.payload;
            return st;

        case types.GET_RECAREA:
            st = cloneState(state);
            st.permit.recarea = action.payload;
            delete st.permit.recarea_err;
            return st;

        case types.GET_RECAREA_ERROR:
            st = cloneState(state);
            st.permit.recarea_err = action.error;
            return st;

        case types.GET_CART:
            st = cloneState(state);
            st.permit.cart = action.payload;
            delete st.permit.cart_err;
            return st;

        case types.GET_CART_ERROR:
            st = cloneState(state);
            st.permit.cart_err = action.payload;
            return st;

        case types.NOTIFY_LOTTERY_RESULTS:
            st = cloneState(state);
            st.permit.notify = action.payload;
            delete st.permit.notify_err;
            return st;

        case types.NOTIFY_LOTTERY_RESULTS_ERROR:
            st = cloneState(state);
            st.notify_err = action.payload;
            return st;

        case types.POST_LOTTERY:
            st = cloneState(state);
            st.permit.lottery = action.payload;
            delete st.permit.lottery_err;
            return st;

        case types.POST_LOTTERY_ERROR:
            st = cloneState(state);
            st.permit.lottery_err = action.payload;
            return st;

        case types.GET_ISSUANCE_PDF_ERROR:
            st = cloneState(state);
            st.permit.fetch_err = action.error;
            return st;

        case types.GET_CAMPSITES:
            st = cloneState(state);
            st.permit.campsites = action.payload;
            delete st.permit.campsites_err;
            return st;

        case types.GET_CAMPSITES_ERROR:
            st = cloneState(state);
            st.permit.campsites_err = action.payload;
            return st;

        case types.POST_ISSUANCE_CALCULATE_FEES:
            st = cloneState(state);
            st.permit.issuance_fee_difference = action.payload;
            return st;

        case types.POST_ISSUANCE_CALCULATE_FEES_ERROR:
            st = cloneState(state);
            st.permit.issuance_fee_difference_err = action.error;
            return st;

        case types.POST_ISSUANCE_CARTLESS:
            st = cloneState(state);
            st.permit.issuance = action.payload;
            delete st.permit.error;
            return st;

        case types.POST_ISSUANCE_CARTLESS_ERROR:
            st = cloneState(state);
            st.permit.error = action.error;
            return st;

        case types.GET_USER_ISSUANCES:
            st = cloneState(state);
            st.permit.user_issuances = action.payload;
            delete st.permit.user_issuances_error;
            return st;

        case types.GET_USER_ISSUANCES_ERROR:
            st = cloneState(state);
            st.permit.user_issuances_error = action.error;
            delete st.permit.user_issuances;
            return st;

        case types.SET_VALIDATION_ERROR:
            st.validation = cloneState(state.validation);
            const { path, error } = action.payload;
            if (error) {
                set(st.validation, path, error);
                st.validation.summary = [
                    ...st.validation.summary.filter((err) => err.path !== path),
                    { path, error },
                ];
            } else {
                unset(st.validation, path, error);
                st.validation.summary = [
                    ...st.validation.summary.filter((err) => err.path !== path),
                ];
            }
            return st;

        case types.SET_PERMIT_TYPE:
            st = cloneState(state);
            st.permitType = action.permitType;
            return st;

        case types.SET_PERMIT_DATE:
            st = cloneState(state);
            st.permitDate = action.permitDate;
            return st;

        case types.SET_SELECTED_DIVISION:
            st = cloneState(state);
            st.selectedDivision = action.division;
            return st;

        case types.SET_SELECTED_START_DATE:
            st = cloneState(state);
            st.selectedStartDate = action.date;
            return st;

        case types.SET_SELECTED_END_DATE:
            st = cloneState(state);
            st.selectedEndDate = action.date;
            return st;

        case types.SET_SELECTED_DIVISION2:
            st = cloneState(state);
            st.selectedDivision2 = action.division;
            return st;

        case types.SET_SELECTED_START_DATE2:
            st = cloneState(state);
            st.selectedStartDate2 = action.date;
            return st;

        case types.SET_SELECTED_END_DATE2:
            st = cloneState(state);
            st.selectedEndDate2 = action.date;
            return st;

        case types.SET_EXISTING_ISSUANCE:
            st = cloneState(state);
            st.permit.existingIssuance = action.existingIssuance;
            return st;

        case types.SET_QUESTIONNAIRE_ANSWERS:
            st = cloneState(state);
            st.questionnaire = { ...st.questionnaire, ...action.answers };
            return st;

        case types.SET_ACTIVE_TAB:
            st = cloneState(state);
            st.activeTab = action.activeTab;
            return st;

        case types.SET_ISSUANCE_LOADING:
            st = cloneState(state);
            st.issuanceLoading = action.issuanceLoading;
            return st;

        case types.SET_DIV_SEARCH_CRITERIA:
            st = cloneState(state);
            st.divisionSearchCriteria = action.divisionSearchCriteria;
            return st;

        case types.FINALIZE_CHECKOUT:
            const confirmation = {
                orderID: action.payload.order_id,
                completedReservations: action.payload.completed_reservations,
                subtotal: action.payload.subtotal,
                tax: action.payload.tax,
                total: action.payload.total,
                modification: action.payload.modification,
            };
            st.order_confirmation = confirmation;
            return st;

        case types.GET_PERMIT_GALLERY:
            st = cloneState(state);
            st.permit.gallery = action.payload;
            return st;

        case types.SET_CLEAR_ISSUANCE_ERRORS:
            st = cloneState(state);
            delete st.permit.fetch_err;
            delete st.permit.lottery_err;
            delete st.permit.cooperators_err;
            delete st.permit.error;
            delete st.permit.availability_err;
            delete st.permit.recarea_err;
            delete st.permit.cart_err;
            delete st.permit.notify_err;
            delete st.permit.campsites_err;
            delete st.permit.user_issuances_error;
            delete st.permit.fetch_issuance_error;
            delete st.agg_season_rules_err;
            return st;

        case types.OPEN_DIVISION_DETAILS_MODAL:
            st = cloneState(state);
            st.divisionDetailsModal.isOpen = true;
            st.divisionDetailsModal.divisionId = action.payload;
            return st;

        case types.CLOSE_DIVISION_DETAILS_MODAL:
            st = cloneState(state);
            st.divisionDetailsModal.isOpen = false;
            st.divisionDetailsModal.divisionId = '';
            return st;

        default:
            return st;
    }
}
